/*
 Absolute Paths is an the centralized place to define paths to be used with routing
*/

//embed
export const EMBEDDED_CANVAS_ROOT = '/embedded-configs/:flowId';
export const EMBEDDED_ACTION_EDIT = '/embedded-configs/:flowId/actions/:actionId/:configRoute?';
export const EMBEDDED_EMAIL_EDITOR = '/embedded-configs/:flowId/actions/:actionId/email/editor/:emailId?';

// platform
export const CANVAS_ROOT = '/platform/flow/:flowId/:screen';
export const CANVAS_ROOT_WORKFLOW = '/platform/flow/:flowId/edit';
export const CANVAS_ROOT_ACTION_SET = '/platform/flow/:flowId/action-set';
export const CANVAS_ROOT_TEST = '/platform/flow/:flowId/edit/test-flow';
export const CANVAS_ROOT_DID_NOT_ENROLL = '/platform/flow/:flowId/edit/enrollment-checks';
export const CANVAS_ROOT_OPTIMIZE = '/platform/flow/:flowId/edit/optimize';
export const ALL_ACTIONS_LIST = '/platform/flow/:flowId/:screen/actions/new-action';
export const PLATFORM_ACTION_EDIT = '/platform/flow/:flowId/:screen/actions/:actionId/:configRoute?';
export const ACTION_SET_CONFIG = '/platform/flow/:flowId/edit/action-set/:actionSetId';
export const STATIC_BRANCH_ACTION_EDIT = '/platform/flow/:flowId/:screen/actions/:actionId/static-branch';
export const PLATFORM_EMAIL_EDITOR = '/platform/flow/:flowId/:screen/actions/:actionId/email/editor/:emailId?';
export const GO_TO_ACTION_EDITOR = '/platform/flow/:flowId/:screen/go-to-edit/:actionId';
export const DATA_SOURCE_EDITOR = '/platform/flow/:flowId/:screen/data-source-edit/:actionId';
export const MOVE_CLONE_EDITOR = '/platform/flow/:flowId/:screen/move-action/:actionId';
export const FLOW_VIEW_ROOT = '/platform/flow/:flowId/view/:viewId';

// Revision preview
export const REVISION_PREVIEW = `/platform/flow/:flowId/revision/:revisionId/preview/edit`;

// enrollment
export const EVENT_ENROLLMENT_CONFIG = `/platform/flow/:flowId/edit/triggers/event`;
export const SCHEDULED_ENROLLMENT_CONFIG = `/platform/flow/:flowId/edit/triggers/scheduled`;
export const LIST_ENROLLMENT_CONFIG = `/platform/flow/:flowId/edit/actions/enrollment/filters`;
export const TRIGGER_SELECTION_ENROLLMENT_CONFIG = `/platform/flow/:flowId/edit/triggers`;
export const EVENT_ENROLLMENT_CONFIG_REVISION_PREVIEW = `/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/event`;
export const SCHEDULED_ENROLLMENT_CONFIG_REVISION_PREVIEW = `/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/scheduled`;
export const LIST_ENROLLMENT_CONFIG_REVISION_PREVIEW = `/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/enrollment/filters`;
export const TRIGGER_SELECTION_REVISION_PREVIEW = `/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers`;

// ai-assistant
export const AI_ASSISTANT = '/platform/flow/:flowId/edit/ai-assistant/:assetType';
export const AI_ASSISTANT_ACTIONS = '/platform/flow/:flowId/edit/ai-assistant/actions';
export const AI_ASSISTANT_TRIGGERS = '/platform/flow/:flowId/edit/ai-assistant/triggers';
export const AI_ASSISTANT_GENERATE_ASSET = '/platform/flow/:flowId/edit/ai-assistant/:assetType/generate';
export const AI_ASSISTANT_GENERATE_TRIGGERS = '/platform/flow/:flowId/edit/ai-assistant/triggers/generate';
export const AI_ASSISTANT_GENERATE_ACTIONS = '/platform/flow/:flowId/edit/ai-assistant/actions/generate';